// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4897 3.57529L12.0002 0.0856934L8.51056 3.57529H3.57553V8.51032L0.0859375 11.9999L3.57553 15.4895V20.4245H8.51056L12.0002 23.9141L15.4897 20.4245H20.4248V15.4895L23.9144 11.9999L20.4248 8.51031V3.57529H15.4897ZM12 7C14.7614 7 17 9.23857 17 12C17 14.7614 14.7614 17 12 17C9.23857 17 7 14.7614 7 12C7 9.23857 9.23857 7 12 7Z"}}]};

const BrightnessFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'brightness-filled',
    ref,
    icon: element,
  },
));

BrightnessFilledIcon.displayName = 'BrightnessFilledIcon';

export default BrightnessFilledIcon;
